import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import { ProfileQueryKey } from './queryKey';
export const useDisable2FA = () => {
    const intl = useIntl();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutation(values => api.base
        .post('/api/user/Disable2FA', values)
        .then(res => res.data), {
        onSuccess: () => {
            queryClient.invalidateQueries([ProfileQueryKey.Profile]);
        },
        onError: apiError => {
            handleHttpError(intl)(apiError);
        },
    });
    return { disable2FA: mutateAsync, isLoading };
};
